export default {
  data() {
    return {
      settings: [],
      routeScan: null,
      cgv: [],
      opMkt: 'N'
    }
  },
  mounted () {
    this.routeScan = this.$route.params.routeScan;
  },
  methods: {
    checkCgv: function() {
      // liste des cases à cochées obligatoires :
      if(this.cgv.includes("1") ) {
        // enregistre en session la réponse opMkt
        if(this.cgv.includes("2")) {
          this.opMkt = 'O';
        } else {
          this.opMkt = 'N';
        }
        // enregistrement en session de la réponse opMkt
        this.$globalService.setSessionSouscription('opMkt',this.opMkt);
        this.$router.push({name: 'ProgressScan'});
        /*
        if(!this.$globalService.isDevicePC(this.$device)){
          //this.$router.push({name: 'ProgressScan'});
          this.$router.push({name: 'ProgressScan'});
        }else{
          //this.$router.push({name: 'QrcodeScan'});
          this.$router.push({name: 'QrcodeScan'});
        }*/
        
      } else {
        this.$dialog.warning({
          text: "Veuillez accepter les conditions générales obligatoires<sup>*</sup> avant de poursuivre",
          title: "Condition générales",
          persistent: true,
        });
      }
    },
    gotoScan: function() {
     
    }
  }

}